import { schema } from 'normalizr';

const LOCATION_DISPLAY_CLASS = 'loca';

// Only maps the keys that are different from their schema counterparts
const PROGRAM_SCHEMA_MAP = {
  university: 'universities',
  city: 'cities',
  province: 'provinces',
  programcategory: 'categories',
  programsubcategory: 'subcategories',
};

function processLocationTemplate(schema) {
  return taggable => ({
    ...taggable,
    schema,
    displayClass: LOCATION_DISPLAY_CLASS,
  });
}

export const categorySchema = new schema.Entity(
  'categories',
  {},
  {
    processStrategy: category => {
      return {
        ...category,
        schema: 'categories',
        displayClass: category.short_name,
      };
    },
  }
);

export const subcategorySchema = new schema.Entity(
  'subcategories',
  {
    // See below for how we define:
    // categories: [tagUnionSchema],
  },
  {
    processStrategy: subcategory => {
      return {
        ...subcategory,
        schema: 'subcategories',
        displayClass: subcategory.categories[0].short_name,
      };
    },
  }
);

export const citySchema = new schema.Entity(
  'cities',
  {},
  {
    processStrategy: processLocationTemplate('cities'),
  }
);

export const provinceSchema = new schema.Entity(
  'provinces',
  {},
  {
    processStrategy: processLocationTemplate('provinces'),
  }
);

export const universitySchema = new schema.Entity(
  'universities',
  {
    // See below for how we define:
    // city: tagUnionSchema,
    // province: tagUnionSchema,
  },
  {
    processStrategy: processLocationTemplate('universities'),
  }
);

export const highlightedTagSchema = new schema.Entity(
  'tags',
  {},
  {
    idAttribute: tag => `${tag.schema}-${tag.id}`,
  }
);

export const tagUnionSchema = new schema.Union(
  {
    categories: categorySchema,
    subcategories: subcategorySchema,
    universities: universitySchema,
    provinces: provinceSchema,
    cities: citySchema,
  },
  (value, parent, key) => {
    if (value.schema) {
      return value.schema;
    }

    if (parent.tagSchema) {
      return parent.tagSchema;
    }

    return PROGRAM_SCHEMA_MAP[key] || key;
  }
);

export const hiddenTagSchema = new schema.Entity(
  'hiddenTags',
  {
    object_content: tagUnionSchema,
  },
  {
    processStrategy: hiddenTag => {
      return {
        ...hiddenTag,
        tagSchema: PROGRAM_SCHEMA_MAP[hiddenTag.object_type],
      };
    },
  }
);

export const hiddenTagListSchema = [hiddenTagSchema];

// Define the recursive nesting!
subcategorySchema.define({ categories: [tagUnionSchema] });
universitySchema.define({ city: tagUnionSchema, province: tagUnionSchema });



// WEBPACK FOOTER //
// ./src/schema/tagSchema.js